import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/core/services/shared.service';
import { MailConfirmationComponent } from '../mail-confirmation/mail-confirmation.component';
import Swal from 'sweetalert2';
import { EncryptService } from 'src/app/core/services/encrypt.service';

@Component({
  selector: 'app-mail-configuration',
  templateUrl: './mail-configuration.component.html',
  styleUrls: ['./mail-configuration.component.scss']
})
export class MailConfigurationComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private sharedService: SharedService,
    public dialog: MatDialog,
    private encrypt: EncryptService,
    public dialogRef: MatDialogRef<MailConfigurationComponent>,
  ) { }

  gmailUser: FormControl = new FormControl(null, Validators.required);
  gmailPassword: FormControl = new FormControl(null, Validators.required);

  registerForm: FormGroup = this.fb.group({
    userName: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    imapServer: new FormControl('', Validators.required),
    imapPort: new FormControl('', Validators.required),
    smtpServer: new FormControl('', Validators.required),
    smtpPort: new FormControl('', Validators.required),
    termsAndConditions: new FormControl(false)
  });

  ngOnInit(): void {
  }

  mailConfirmation() {
    const dialogRef = this.dialog.open(MailConfirmationComponent, {
      width: '60vw',
      height: '40vw',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
      }
    });
  }

  configureMail() {
    let submitData: any;
    if (this.data.configType === 'gmail') {
      let username = this.encrypt.generateEncryption(this.gmailUser.value);
      let password = this.encrypt.generateEncryption(this.gmailPassword.value);
      submitData = {
        username: username,
        password: password,
        smtpHost: 'smtp.gmail.com',
        smtpPort: '465',
        imapHost: 'imap.gmail.com',
        imapPort: '993',
        type: 'GMAIL',
        isActive: true,
        mode: 'LAST_10_DAYS'
      }
    } else if (this.data.configType === 'yahoo') {
      let username = this.encrypt.generateEncryption(this.gmailUser.value);
      let password = this.encrypt.generateEncryption(this.gmailPassword.value);
      submitData = {
        username: username,
        password: password,
        smtpHost: 'smtp.mail.yahoo.com',
        smtpPort: '465',
        imapHost: 'imap.mail.yahoo.com',
        imapPort: '993',
        type: 'YAHOO',
        isActive: true,
        mode: 'LAST_10_DAYS'
      }
    } else if (this.data.configType === 'outlook') {
      let username = this.encrypt.generateEncryption(this.gmailUser.value);
      let password = this.encrypt.generateEncryption(this.gmailPassword.value);
      submitData = {
        username: username,
        password: password,
        smtpHost: 'smtp.office365.com',
        smtpPort: '587',
        imapHost: 'outlook.office365.com',
        imapPort: '993',
        type: 'MICROSOFT',
        isActive: true,
        mode: 'LAST_10_DAYS'
      }
    } else if (this.data.configType === 'other') {
      let username = this.encrypt.generateEncryption(this.registerForm.value.userName);
      let password = this.encrypt.generateEncryption(this.registerForm.value.password);
      submitData = {
        smtpHost: this.registerForm.value.smtpServer,
        smtpPort: this.registerForm.value.smtpPort,
        imapHost: this.registerForm.value.imapServer,
        imapPort: this.registerForm.value.imapPort,
        username: username,
        password: password,
        type: 'OTHERS',
        isActive: true,
        mode: 'LAST_10_DAYS'
      }
    }
    //Creating final SubmitData object 
    this.sharedService.configureMailbox(submitData).subscribe(
      (res: any) => {
        this.mailConfirmation();
        this.dialogRef.close('success');
      },
      (err: any) => {
        Swal.fire('', err ? err : err, 'error');
      }
    );
  }

}
